import { NgForOf, NgIf } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { PortalFieldTypeConfig } from '@portal/form/data-access';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'portal-application-acknowledgement',
  standalone: true,
  imports: [FormlyModule, ReactiveFormsModule, MatIconModule, NgIf, NgForOf, MatCheckboxModule],
  templateUrl: './acknowledgement.component.html',
  styles: [':host {@apply block mt-2;}'],
})
export class AcknowledgementComponent extends FieldType<PortalFieldTypeConfig> {
  override defaultOptions = { props: { color: 'primary' as const, labelPosition: 'after' as const } };
}

@NgModule({
  imports: [
    FormlyModule.forChild({
      types: [
        {
          name: 'form-acknowledgement',
          wrappers: ['form-field'],
          component: AcknowledgementComponent,
        },
      ],
    }),
  ],
})
export class AcknowledgementModule {}
